import { useNavigate } from "react-router-dom";

import { FinanceReceivableOverviewFeaturePage } from "..";

/** 应收列表页面：点「详情」进这个团的应收清单（地址上带订单 ID）。 */
export function FinanceReceivableOverviewPage() {
  const navigate = useNavigate();
  return (
    <FinanceReceivableOverviewFeaturePage
      onOpenDetail={(orderId) => navigate(`/finance/receivables?${new URLSearchParams({ orderId }).toString()}`)}
    />
  );
}
